<template>
    <section v-if="id > 0" class="form-section">
        <div>
            <h3 class="form-title">{{ form.title }}</h3>
        </div>

        <div class="form-wrap">
            <div class="fields-wrap">
                <template v-for="item in form.fields">
                    <div class="field-box">
                        <label v-if="item.type !== 5" class="field-label">{{ item.label }} <span v-if="item.is_require" class="field-required">*</span></label>

                        <div v-if="item.type === 2" class="field-element">
                            <textarea style="width: 100%;" rows="4" v-model="item.value" />
                            <div class="error-messages">{{ messageFieldError(item.name) }}</div>
                        </div>

                        <div v-else-if="item.type === 5" class="field-element">
                            <div style="display: flex; width: 100%;">
                                <div style="width: 50%; padding-right: 2px;">
                                    <label class="field-label">{{ item.label }} <span v-if="item.is_require" class="field-required">*</span></label>
                                    <input type="text" style="width: 100%;" v-mask="phoneFormat" v-model="item.value" />
                                </div>
                                <div style="width: 50%;">
                                    <label class="field-label">Phone format</label>
                                    <select v-model="phoneFormat" style="width: 100%;">
                                        <option v-for="(format, i) in phoneFormats" :key="i" :value="format.value">
                                            {{ format.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="error-messages">{{ messageFieldError(item.name) }}</div>
                        </div>

                        <div v-else-if="item.type === 6" class="field-element">
                            <input type="number" style="width: 100%;" v-model="item.value" />
                            <div class="error-messages">{{ messageFieldError(item.name) }}</div>
                        </div>

                        <div v-else-if="item.type === 7" class="field-element">
                            <input type="text" style="max-width: 180px; width: 100%;" v-model="item.value" placeholder="mm/dd/yyyy" maxlength="10" @input="onInput($event, item)" />
                            <div class="error-messages">{{ messageFieldError(item.name) }}</div>
                        </div>

                        <div v-else-if="item.type === 8" class="field-element">
                            <select style="width: 100%;" v-model="item.value">
                                <option v-for="(el, i) in item.items" :key="i" :value="el">
                                    {{ el }}
                                </option>
                            </select>
                            <div class="error-messages">{{ messageFieldError(item.name) }}</div>
                        </div>

                        <div v-else-if="item.type === 9" class="field-element">
                            <div v-for="(el, i) in item.items" :key="i">
                                <label style="display: flex; align-items: center;">
                                    <input type="radio" v-model="item.value" :value="el" />
                                    <span style="display: block; margin-left: 12px;">{{ el }}</span>
                                </label>
                            </div>
                            <div class="error-messages">{{ messageFieldError(item.name) }}</div>
                        </div>

                        <div v-else-if="item.type === 10" class="field-element">
                            <div v-for="(el, i) in item.items" :key="i">
                                <label style="display: flex; align-items: center;">
                                    <input type="checkbox" v-model="item.value" :value="el" />
                                    <span style="display: block; margin-left: 12px;">{{ el }}</span>
                                </label>
                            </div>
                            <div class="error-messages">{{ messageFieldError(item.name) }}</div>
                        </div>

                        <div v-else class="field-element">
                            <input type="text" style="width: 100%;" v-model="item.value" />
                            <div class="error-messages">{{ messageFieldError(item.name) }}</div>
                        </div>
                    </div>
                </template>

                <div style="text-align: right; padding: 8px 0;">
                    <hr style="margin-top: 0;" />
                    <button :disabled="isLoading" type="button" @click="sendForm">Submit</button>
                </div>
            </div>
        </div>

        <div class="popup"  :style="'display: ' + (isSent ? 'block' : 'none')" @click="isSent = false">
            <div class="popup-content" style="max-width: 300px;">
                <template>
                    <div style="padding: 16px 0;">
                        <div style="font-weight: bold; text-align: center; color: green;">Form sent successfully</div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import EditorComponent from "./EditorComponent.vue";
import notifications from "../mixins/notifications";
import moment from "moment/moment";

export default {
    name: "FormComponent",
    mixins: [
        notifications
    ],
    components: {
        EditorComponent
    },
    props: {
        id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isLoading: false,
            isSent: false,
            form: {
                title: '',
                fields: []
            },
            phoneFormat: '(###) ###-####',
            phoneFormats: [
                { text: '(123) 456-7890', value: '(###) ###-####' },
                { text: '123-456-7890', value: '###-###-####' },
                { text: '123.456.7890', value: '###.###.####' },
                { text: '123-4567890', value: '###-#######' },
                { text: '123/456-7890', value: '###/###-####' },
                { text: '+11234567890', value: '+1##########' },
            ],
        }
    },
    watch: {
        '$refs.dateInput': function (value) {
            console.log(value)
        }
    },
    mounted() {
        if (this.id > 0) {
            this.loadData();
        }
    },
    methods: {
        loadData() {
            this.isLoading = true;

            this.$api.get('forms/' + this.id).then(response => {
                if (response.data) {
                    this.form = response.data;

                    this.form.fields = this.form.fields.map((item) => {
                        if (item.type === 10) {
                            item.value = [];
                        }

                        return item;
                    });
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        sendForm() {
            this.clearValidateErrors();

            this.isLoading = true;

            this.form.phone_length = this.phoneFormat.length;

            this.$api.post('forms/' + this.id + '/send', this.form).then(response => {
                if (response.data && response.data.status) {
                    if (response.data.status === 'success') {
                        this.isSent = true;
                        this.clearForm();
                    }

                    if (response.data.status === 'error') {
                        this.setValidateErrors({
                            body: [response.data.message]
                        });
                    }
                }
            }).catch((error) => {
                if (error.response && error.response.data.errors) {
                    this.setValidateErrors(error.response.data.errors);
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        clearForm() {
            this.form.fields = this.form.fields.map((item) => {
                item.value = item.type === 10 ? [] : '';

                return item;
            });
        },
        onInput(event, item) {
            let value = event.target.value.replace(/\D/g, '');

            if (value.length >= 5) {
                const mm = this.month(value.slice(0, 2));
                const dd = this.day(value.slice(2, 4), mm);

                value = mm + '/' + dd + '/' + value.slice(4, 8);
            } else if (value.length >= 3) {
                const mm = this.month(value.slice(0, 2));
                const dd = this.day(value.slice(2, 4), mm);

                value = mm + '/' + dd + (value.length > 4 ? '/' + value.slice(4, 8) : '');
            } else if (value.length > 2) {
                const mm = this.month(value.slice(0, 2));

                value = mm + '/' + value.slice(2);
            }

            item.value = value;
        },
        daysInMonth(month) {
            return moment(month, 'MM').daysInMonth();
        },
        month(value) {
            return (+value > 12 ? 12 : (value === '00' ? '01' : value));
        },
        day(value, month) {
            const daysInMonth = this.daysInMonth(month);

            return (+value > daysInMonth ? daysInMonth : (value === '00' ? '01' : value));
        }
    }
}
</script>

<style lang="scss">
body.modal-open {
    overflow: hidden;
}

.popup-content {
    .ck-editor__editable_inline {
        min-height: 300px!important;
    }
}
</style>

<style scoped lang="scss">
.form-section {
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
}

.form-title {
    font-size: 1.5em;
    text-align: center;
}

.field-box {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
}

.field-label {
    display: block;
}

.field-required {
    color: red;
}

input:not([type=radio]):not([type=checkbox]), select {
    border: 1px solid #ccced1;
    padding: 0 8px;
    height: 34px!important;
}

.error-messages {
    color: red;
    font-size: 0.8em;
    width: 100%;
}

button {
    background: #ffffff;
    min-width: 100px;
    border: 1px solid #000000;
    border-radius: 4px;
    height: 34px!important;
}

button.send {
    border-color: green;
    color: green;
}

button.send:focus, button.send:focus-visible {
    border-color: green!important;
}

button:hover {
    background: #f0f0f0;
}

.popup {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999;
}

.popup-content {
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 28px 20px 20px 20px;
    border-radius: 5px;
    overflow-y: auto;
    width: 100%;
    max-height: 90vh;
}
</style>
